export enum FinancialStatus {
  PAYOUT_REQUEST_STATUS_UNSPECIFIED,
  PAYOUT_REQUEST_STATUS_NEW,
  PAYOUT_REQUEST_STATUS_PROGRESS,
  PAYOUT_REQUEST_STATUS_PAID,
  PAYOUT_REQUEST_STATUS_CANCELED,
}
